(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tp-floating-quiz-trigger"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        const floatingQuizTrigger = document.querySelector('.floating-quiz-trigger');
        if (!floatingQuizTrigger) return;

        const closeIcon = floatingQuizTrigger.querySelector('.icon__close');
        if (!closeIcon) return;

        if (sessionStorage.getItem('floatingQuizTriggerClosed')) {
            floatingQuizTrigger.remove();
            return;
        } else {
            floatingQuizTrigger.setAttribute('data-active', 'true');
        }

        closeIcon.addEventListener('click', function() {
            floatingQuizTrigger.remove();
            sessionStorage.setItem('floatingQuizTriggerClosed', 'true');
        });
    });
  } catch(e) { console.error(e); }
})();

})();
